import React, { useContext, useEffect, useState } from 'react';
import { Button, Label, Segment } from 'semantic-ui-react';
import { AppAccessContext } from '../../../../global/cnr/contexts/AppAccessContext';
import { uniqueKey } from '../../../../global/common/keys';
import { NumberPad, numberPadTypes } from '../../../../global/components/forms/elements/NumberPad';
import UiRequestAccess from '../../../../global/pageItem/modification/userActions/UiRequestAccess';
import { SportsEditMatchContext } from '../../cnr/contexts/SportsEditMatchContext';
import { SportsSeasonContext } from '../../cnr/contexts/SportsSeasonContext';
import { gameScoringTypes } from '../../cnr/reducers/SportsSeasonReducer';
import { matchCalcs } from '../../helpers/match';
import GameScoring from './GameScoring';
import MatchScoreKeypad, { _keypadTypes } from './MatchScoreKeypad';
import MatchScoreTable from './MatchScoreTable';

const MatchItemScoring = (props) => {

  const { setScoring } = props

  // sportsSeasonContext
  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state } = sportsSeasonContext
  const { currentUserId, currentSeason_info } = sportsSeason_state ?? {}
  const { gameScoringType, gameAllowTies, _sportsModeSport } = currentSeason_info ?? {}

  const sportsEditMatchContext = useContext(SportsEditMatchContext)
  const { sportsEditMatch_state, sportsEditMatch_handlers } = sportsEditMatchContext ?? {}
  const { match_edit, matchAllows } = sportsEditMatch_state ?? {}
  const { scores: _allowEdit_scores, scoresRt: _allowEdit_scoresRt } = matchAllows ?? {}

  const _allowScoreEdit = _allowEdit_scores || _allowEdit_scoresRt

  // appAccessContext
  const appAccessContext = useContext(AppAccessContext)
  const { appAccess_fns } = appAccessContext ?? {}

  const [showRequest, setShowRequest] = useState()
  const [currentScoringSet, setCurrentScoringSet] = useState(1)

  const { _results } = match_edit ?? {}
  const results = match_edit ? match_edit._results : undefined;
  const rez = _results && (_results.scores || _results.score) ? _results : results
  const { score: score_match, complete } = rez ?? {}

  useEffect(() => {
    if (!_results) {
      sportsEditMatch_handlers.handleAmmend_editMatch(match_edit, true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [results]);

  const handleScoreChange = (e, data) => {
    const { value: score, opts } = data
    const { team, setNumber } = opts
    const _currentMatch = { ...match_edit }
    if (!_currentMatch._results) { _currentMatch._results = { setNumber: 1, score: { home: 0, away: 0 } } }
    if (!_currentMatch._results.score) { _currentMatch._results.score = { home: 0, away: 0 } }
    _currentMatch._results.score[team] = score
    matchCalcs.calcVballMatch(_currentMatch, gameScoringType)
    matchCalcs.calcVballMatch_display(_currentMatch, gameScoringType)
    sportsEditMatch_handlers.handleChange_score(score, team, setNumber)
  }

  const handleScorePad = (e, team, score) => {
    e.preventDefault()
    e.stopPropagation()
    sportsEditMatch_handlers.handleAmmend_editMatchScore(team, score)
  }

  const scoreLabel = (score, team) => <Label key={uniqueKey('mis', 'sc', 'sl', team)} color={(complete ? 'green' : 'grey')}>{score}</Label>

  const teamScoreLabel = (team, score, allowSet, teamSetScore) => {
    const teamScore = score_match && score_match[team] ? score_match[team] : 0
    let color = teamScore === score ? 'blue' : 'black'
    let disabled = false
    if (score === 3) {
      if (team === 'home') {
        if (score_match && score_match.away && score_match.away === 3) {
          disabled = true
        }
      } else {
        if (score_match && score_match.home && score_match.home === 3) {
          disabled = true
        }
      }
    }

    const lineScoring = () => <NumberPad value={teamSetScore} onChange={handleScoreChange} numberPadType={numberPadTypes.grid} opts={{ team, setNumber: score, disabled: !allowSet, noSize: true }} />

    return setScoring ?
      lineScoring()
      :
      <Label
        key={uniqueKey('mis', 'l', team, score)}
        color={(disabled ? 'grey' : color)}
        onClick={(e) => { !disabled && handleScorePad(e, team, score) }}>
        {score}
      </Label>
  }

  // 0 - 1 - 2 - 3
  const teamScoreColumn = (team, name) => {

    const max = 4
    const divs = []
    const teamScore = score_match && score_match[team] ? score_match[team] : 0

    divs.push(<div key={uniqueKey('mis', team, 'n')}>{name}</div>)
    divs.push(scoreLabel(teamScore, team))

    switch (gameScoringType) {
      case gameScoringTypes.match:
      case gameScoringTypes.matchPoints:

        divs.push(<div key={uniqueKey('mis', team, 's')}>{'Sets'}</div>)

        const divvs = Array.from({ length: max }, (_, index) => teamScoreLabel(team, index));
        const _divs = [...divs, ...divvs]

        return <div key={uniqueKey('mis', team, 'ts')} className={'team-score'}>{_divs}</div>

      case gameScoringTypes.half:
        return <div key={uniqueKey('mis', team, 'ts')} className={'team-score'}>{divs}</div>

      case gameScoringTypes.quarter:
        return <div key={uniqueKey('mis', team, 'ts')} className={'team-score'}>{divs}</div>

      default:
      // nothing
    }
  }

  const teamScoringColumns = () => currentScoringSet ?
    <MatchScoreKeypad keypadType={_keypadTypes.normal} /> :
    <MatchScoreKeypad keypadType={setScoring ? _keypadTypes.realtime : _keypadTypes.normal} />

  // scores - score - scores
  const teamScoring = () => {
    switch (gameScoringType) {
      case gameScoringTypes.match:
      case gameScoringTypes.matchPoints:
        return <React.Fragment>
          <MatchScoreTable />
          {teamScoringColumns()}
        </React.Fragment>
      case gameScoringTypes.half:
      case gameScoringTypes.quarter:
        return <GameScoring match_edit={match_edit} />
      default:
      // nothing
    }
  }

  // scores - score - scores
  const teamScores = () => {
    return <div className={'team-scores'}>
      {teamScoreColumn('away', match_edit.away.name)}
      {teamScoreColumn('home', match_edit.home.name)}
    </div>
  }

  const request = () => <Segment.Group>
    <Segment>{'You do not have permission to update this match'}{'?'}</Segment>
    <Segment textAlign={'right'}>
      <Button size={'small'} color={'blue'} onClick={(e) => { setShowRequest(true) }}>Request Access</Button>
      <Button size={'small'} onClick={(e) => { setShowRequest() }}>Close</Button>
    </Segment>
  </Segment.Group>

  const matchScoringUpdate = () => {
    if (!_allowScoreEdit) {
      return showRequest ? requestAccess() : request()
    } else {
      return <div className={'scoring-update'}>
        {setScoring ? teamScoring() : teamScores()}
      </div>
    }
  }

  const requestAccess = () => <UiRequestAccess direct={true} directCancel={setShowRequest} />

  return matchScoringUpdate()
}

export default MatchItemScoring

